import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from 'primeng/progressbar';
import { ProgressBarModule } from 'primeng/progressbar';
import * as i3 from 'primeng/overlaypanel';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import * as i4 from 'primeng/api';
function FilePreviewListComponent_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const file_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("background-image", "url(" + file_r1.file + ")");
  }
}
function FilePreviewListComponent_div_1_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "i");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const file_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(file_r1.icon);
  }
}
function FilePreviewListComponent_div_1_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "i", 14);
    i0.ɵɵlistener("click", function FilePreviewListComponent_div_1_div_7_Template_i_click_1_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const file_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r12 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r12.handleDownloadButtonClick($event, file_r1));
    });
    i0.ɵɵelementEnd()();
  }
}
function FilePreviewListComponent_div_1_div_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "i", 16);
    i0.ɵɵlistener("click", function FilePreviewListComponent_div_1_div_8_Template_i_click_1_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r16 = i0.ɵɵnextContext();
      const file_r1 = ctx_r16.$implicit;
      const index_r2 = ctx_r16.index;
      const ctx_r15 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r15.handleDeleteButtonClick($event, file_r1, index_r2));
    });
    i0.ɵɵelementEnd()();
  }
}
function FilePreviewListComponent_div_1_div_9_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵlistener("click", function FilePreviewListComponent_div_1_div_9_ng_template_3_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r22);
      const file_r1 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r20 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r20.handleDownloadButtonClick($event, file_r1));
    });
    i0.ɵɵelement(1, "i", 23);
    i0.ɵɵelementStart(2, "span", 24);
    i0.ɵɵtext(3, "Download");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 25);
    i0.ɵɵlistener("click", function FilePreviewListComponent_div_1_div_9_ng_template_3_Template_div_click_4_listener($event) {
      i0.ɵɵrestoreView(_r22);
      const ctx_r24 = i0.ɵɵnextContext(2);
      const file_r1 = ctx_r24.$implicit;
      const index_r2 = ctx_r24.index;
      const ctx_r23 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r23.handleDeleteButtonClick($event, file_r1, index_r2));
    });
    i0.ɵɵelement(5, "i", 26);
    i0.ɵɵelementStart(6, "span", 24);
    i0.ɵɵtext(7, "Delete");
    i0.ɵɵelementEnd()();
  }
}
function FilePreviewListComponent_div_1_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "p-overlayPanel", 18, 19);
    i0.ɵɵtemplate(3, FilePreviewListComponent_div_1_div_9_ng_template_3_Template, 8, 0, "ng-template", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "i", 21);
    i0.ɵɵlistener("click", function FilePreviewListComponent_div_1_div_9_Template_i_click_4_listener($event) {
      i0.ɵɵrestoreView(_r26);
      const _r18 = i0.ɵɵreference(2);
      return i0.ɵɵresetView(_r18.toggle($event));
    });
    i0.ɵɵelementEnd()();
  }
}
function FilePreviewListComponent_div_1_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "p-progressBar", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const file_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", file_r1.uploadProgress)("showValue", false);
  }
}
function FilePreviewListComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵlistener("click", function FilePreviewListComponent_div_1_Template_div_click_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r29);
      const file_r1 = restoredCtx.$implicit;
      const index_r2 = restoredCtx.index;
      const ctx_r28 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r28.handleItemClick(file_r1, index_r2));
    });
    i0.ɵɵtemplate(1, FilePreviewListComponent_div_1_ng_container_1_Template, 2, 2, "ng-container", 3);
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, FilePreviewListComponent_div_1_ng_template_4_Template, 2, 2, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(6, "div", 6);
    i0.ɵɵtemplate(7, FilePreviewListComponent_div_1_div_7_Template, 2, 0, "div", 7);
    i0.ɵɵtemplate(8, FilePreviewListComponent_div_1_div_8_Template, 2, 0, "div", 8);
    i0.ɵɵtemplate(9, FilePreviewListComponent_div_1_div_9_Template, 5, 0, "div", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, FilePreviewListComponent_div_1_div_10_Template, 2, 2, "div", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const file_r1 = ctx.$implicit;
    const _r4 = i0.ɵɵreference(5);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", file_r1.isImage)("ngIfElse", _r4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(file_r1.name);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.showDownload && !ctx_r0.showDelete);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showDelete && !ctx_r0.showDownload);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showDelete && ctx_r0.showDownload);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", file_r1.uploading);
  }
}
let FilePreviewListComponent = /*#__PURE__*/(() => {
  class FilePreviewListComponent {
    constructor() {
      this.onDeleteClick = new EventEmitter();
      this.onDownloadClick = new EventEmitter();
      this.itemClick = new EventEmitter();
      this.fileIconMap = [{
        fileTypes: ['docx', 'doc', 'docm'],
        fileIcon: 'fas fa-file-word'
      }, {
        fileTypes: ['pdf'],
        fileIcon: 'fas fa-file-pdf'
      }, {
        fileTypes: ['xlsx', 'xlsm', 'xlsb', 'xltx', 'xls'],
        fileIcon: 'fas fa-file-excel'
      }, {
        fileTypes: ['csv'],
        fileIcon: 'fas fa-file-csv'
      }, {
        fileTypes: ['png', 'jpg', 'jpeg', 'gif'],
        fileIcon: 'fas fa-file-image'
      }];
      this.imageFileTypes = ['png', 'jpg', 'jpeg', 'gif'];
    }
    get files() {
      return this._files;
    }
    set files(value) {
      this._files = value;
      if (value) {
        this.formattedFileList = this.getFormattedFileList(value);
      }
    }
    getFormattedFileList(files) {
      return files.map(file => {
        const splitFileName = file.name.split('.');
        const extension = splitFileName[splitFileName.length - 1];
        // check if it is an image
        if (file.url && this.imageFileTypes.includes(extension)) {
          return {
            file: file.url,
            isImage: true,
            name: file.name,
            uploading: file.uploading,
            uploadProgress: file.uploadProgress,
            id: file.id
          };
        } else {
          const icon = this.fileIconMap.find(fileIconMap => {
            return fileIconMap.fileTypes.includes(extension);
          });
          return {
            file: file.url,
            isImage: false,
            icon: icon ? icon.fileIcon : 'fas fa-file-alt',
            name: file.name,
            uploading: file.uploading,
            uploadProgress: file.uploadProgress,
            id: file.id
          };
        }
      });
    }
    trackByIndex(index) {
      return index;
    }
    handleItemClick(file, index) {
      this.itemClick.emit({
        file,
        index
      });
    }
    handleDeleteButtonClick(event, file, index) {
      event.stopPropagation();
      this.onDeleteClick.emit({
        id: file.id,
        index: index,
        name: file.name,
        url: file.file
      });
    }
    handleDownloadButtonClick(event, file) {
      event.stopPropagation();
      this.onDownloadClick.emit(file);
    }
    static {
      this.ɵfac = function FilePreviewListComponent_Factory(t) {
        return new (t || FilePreviewListComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FilePreviewListComponent,
        selectors: [["cap-file-preview-list"]],
        inputs: {
          showDelete: "showDelete",
          showDownload: "showDownload",
          files: "files"
        },
        outputs: {
          onDeleteClick: "onDeleteClick",
          onDownloadClick: "onDownloadClick",
          itemClick: "itemClick"
        },
        decls: 2,
        vars: 2,
        consts: [[1, "cap-file-preview-list"], ["class", "cap-file-preview-list__item", 3, "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "cap-file-preview-list__item", 3, "click"], [4, "ngIf", "ngIfElse"], [1, "file-name"], ["defaultTemplate", ""], [1, "file-actions"], ["class", "download-file-icon", 4, "ngIf"], ["class", "remove-file-icon file-delete", 4, "ngIf"], ["class", "file-actions-menu", 4, "ngIf"], ["class", "loading-overlay", 4, "ngIf"], [1, "cap-file-preview-list__preview-image"], [1, "cap-file-preview-list__preview-icon"], [1, "download-file-icon"], [1, "fas", "fa-download", 3, "click"], [1, "remove-file-icon", "file-delete"], [1, "fas", "fa-trash-alt", 3, "click"], [1, "file-actions-menu"], ["styleClass", "cap-file-preview-action-panel"], ["overlayPanel", ""], ["pTemplate", ""], [1, "fas", "fa-ellipsis-v", 3, "click"], [1, "cap-file-action-item", "file-download", 3, "click"], [1, "fas", "fa-download"], [1, "cap-file-action-label"], [1, "cap-file-action-item", "file-delete", 3, "click"], [1, "fas", "fa-trash-alt"], [1, "loading-overlay"], [3, "value", "showValue"]],
        template: function FilePreviewListComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, FilePreviewListComponent_div_1_Template, 11, 7, "div", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.formattedFileList)("ngForTrackBy", ctx.trackByIndex);
          }
        },
        dependencies: [i1.NgForOf, i1.NgIf, i2.ProgressBar, i3.OverlayPanel, i4.PrimeTemplate],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return FilePreviewListComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumFilePreviewListModule = /*#__PURE__*/(() => {
  class CapturumFilePreviewListModule {
    static {
      this.ɵfac = function CapturumFilePreviewListModule_Factory(t) {
        return new (t || CapturumFilePreviewListModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumFilePreviewListModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, ProgressBarModule, OverlayPanelModule]
      });
    }
  }
  return CapturumFilePreviewListModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CapturumFilePreviewListModule, FilePreviewListComponent };
